import { render, staticRenderFns } from "./VerticalTab.vue?vue&type=template&id=97778ee0&scoped=true"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"
import style0 from "./VerticalTab.vue?vue&type=style&index=0&id=97778ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97778ee0",
  null
  
)

export default component.exports